export default {
  level2: '2',
  level4: '4',
  level5: '5',
  level10: '10',
};
